import {useMapContext} from '@/components/MindMap/index.mjs'

export default function SelectedNodes(props) {
    const map = useMapContext()
    const selectedNodes = map.useSelectedNodes()

    const text = (() => {
        if (0 < selectedNodes.size) {
            const [nodeCount, type] = (() => {
                let nodeCount = 0
                let type = null

                for (const node of selectedNodes) {
                    const {bizNodeType} = node.data
                    nodeCount += 1

                    if (null === type) {
                        type = bizNodeType
                    }
                    else if (type !== bizNodeType) {
                        type = ''
                    }
                }

                return [
                    nodeCount,
                    type ? map.BizNode[type].typeName(map) : '节点',
                ]
            })()

            const tree = map.treelize(selectedNodes)

            const descendantCount = tree.reduce(
                (count, [node]) => count + map.descendantCount.getCount(node),
                0
            )

            return `已选择 ${nodeCount} 个${type}，共 ${descendantCount} 个子节点`
        }
        else {
            const nodeCount = map.descendantCount.getCount(map.root) + 1
            return `共 ${nodeCount} 个节点`
        }
    })()

    return (
        <div {...props}>{text}</div>
    )
}
